import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const LeadershipSection: React.FC = () => {
  return (
    <section
      className="h-auto lg:h-full relative flex flex-col lg:flex-row items-center justify-center gap-6 sm:gap-8 lg:gap-16 px-6 sm:px-2 py-16 sm:py-20 lg:pt-10 lg:px-12 overflow-hidden"
      aria-label="Leadership"
    >
      {/* Background image - no overlay; section can extend behind navbar */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: "url('/assets/images/leadership-bg.webp')" }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-transparent to-black opacity-50"></div>

      {/* Content pushed down so it does not sit behind navbar */}
      <div className="relative z-10 w-full mx-auto flex flex-col lg:flex-row items-center justify-center gap-y-10 lg:gap-6 text-center lg:text-left pt-20">
        {/* Circular portrait */}
        <div className="flex-shrink-0 w-[240px] h-[240px] lg:w-[300px] lg:h-[300px]">
          <img
            src="/assets/logos/chairmen.webp"
            alt="Leadership"
            className="w-full h-full rounded-full object-cover border-2 border-white shadow-xl"
          />
        </div>

        {/* Text and CTA */}
        <div className="flex flex-col items-center lg:items-start text-center lg:text-left">
          <h1 className="text-[32px] md:text-[42px]  font-bold font-open-sans-hebrew text-white leading-tight mb-2">
            Redefining the Future of Plywood & Panel Solutions
          </h1>
          <h2 className="text-[28px] md:text-[36px] lg:text-[40px] font-bold font-open-sans-hebrew text-white leading-tight mb-4">
            Pioneering Plywood Since 1985
          </h2>
          <p className="text-[16px] md:text-[18px] font-raleway font-normal text-gray-300 leading-relaxed max-w-lg mb-6">
            Driving the future of the sector with the launch of ultra-modern,
            next-gen technology at Croma Ply.
          </p>
          <Link
            to="/about"
            className="inline-flex items-center group gap-2 px-6 py-3 rounded-lg text-sm font-raleway font-semibold text-white bg-[#E30026] hover:bg-[#c40022] border-b-2 border-croma-blue transition-colors shadow-md"
          >
            Leadership Journey
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>
      </div>
    </section>
  );
};
